module.exports = "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYTg0Y2RiY2JhNjg5MDMyMjFhY2NkNDUxYjQ4YjNjNWEuc3ZnIjs="